//Models
PJQ.models.projectParticipants = {};

PJQ.models.projectParticipants.ProjectParticipant = PJQ.models.contacts.Contact.extend({
	endpoint: function () {
		let endpointArr = [
			{
				endpoint: 'projects',
				value: this.project ? this.project.id : this.get('projectId')
			},
			{
				endpoint: 'participants',
				value: this.get('id')
			}
		];

		if (this.get('isUpdateBidAmount'))
			endpointArr.push({endpoint: 'bidamount'});

		return PJQ.helpers.urlHelpers.generateEndpoint(endpointArr);
	},
	parse: function (model) {
		if (model && model.project) {
			this.project = model.project;
		}
		PJQ.models.contacts.Contact.prototype.parseContactData.call(this, model);
		PJQ.models.contacts.Contact.prototype.parseAttachmentData.call(this, model);
		return model;
	},
	getCompanyCustomField: function (customFieldId) {
		return _.find(this.get('companyCustomFieldValues'), function (cf) {
			return (cf.id === customFieldId);
		});
	},
	getContactCustomField: function (customFieldId) {
		return _.find(this.get('contactCustomFieldValues'), function (cf) {
			return (cf.id === customFieldId);
		});
	},
	beforeSave: function () {
		PJQ.models.contacts.Contact.prototype.beforeSave.call(this);
		this.set({
			attachments: this.attachments.getChangedModels()
		})
	}
});

//Collections
PJQ.collections.projectParticipants = {};

PJQ.collections.projectParticipants.ProjectParticipants = PJQ.collections.BaseCollection.extend({
	idAttribute: 'id',
	model: PJQ.models.projectContacts.ProjectContact,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.options.project.id
			},
			{
				endpoint: 'participants'
			}
		], [
			{
				parameter: 'includeGroups',
				value: true
			}
		])
	}
});

//Views
PJQ.views.projectParticipants = {};

PJQ.views.projectParticipants.AddParticipantsModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Add-Participants'),
		addButtonText: "Add Participants",
		isDirectoryEnabled: false,
		isUnionStatusEnabled: false,
		isReturnContactIds: false,
		defaultDirectoryFilter: [1],
		defaultRadius: 50,
		defaultZip: '',
		groupSelectorOptions: {},
		onSave: _.noop,
		onCancel: _.noop
	},
	events: {
		"click .add-participants-cancel": "onCancel",
		"click .add-participants-save": "onSave",
		'keyup .add-participants-radius': 'radiusChanged',
		'keyup .add-participants-zip': 'zipChanged',
		"keydown .add-participants-radius": "numbersOnly",
		"click .send-message-save": "sendMessage"
	},
	beforeModalCreated: function () {
		this.options.isWorkAreasEnabled = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_WORK_AREAS);

		let projectZip = this.model.get('zip');
		if (_.size(projectZip) > 0) {
			this.options.defaultZip = projectZip;
		}

		this.model.fetchBidPackages(_.bind(function (bp) {
			this.bidPackages = bp;
			this.render();
		}, this));
	},
	renderData: function () {
		return {
			options: this.options
		};
	},
	zipChanged: function () {
		let zipInput = this.$('.add-participants-zip');
		if (PJQ.helpers.validators.validateZip(zipInput.val())) {
			PJQ.helpers.inputHelpers.setInputError(zipInput, true);
		}
	},
	afterRender: function () {
		if (this.options.isDirectoryEnabled) {
			let directoryFilter = this.options.defaultDirectoryFilter ? this.options.defaultDirectoryFilter : [];
			if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.SIMPLE_SEARCH_DEFAULT_ADDRESS_BOOK)) {
				let directoryFilterStr = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.SIMPLE_SEARCH_DEFAULT_ADDRESS_BOOK).toLowerCase();
				if (directoryFilterStr.indexOf('private') !== -1) {
					directoryFilter.push(1);
				}
				if (directoryFilterStr.indexOf('public') !== -1) {
					directoryFilter.push(2);
				}
			}
			this.directoryFilterSelectPicker = new PJQ.inputs.Selectpicker({
				el: this.$('.add-participants-directory-filter'),
				isIntChoices: true,
				isMultiple: true,
				defaultValue: directoryFilter,
				onChange: _.bind(function () {
					this.renderGroups();
					this.directoryFilterSelectPicker.hideError();
				}, this)
			});
		}

		this.unionFilterSelectPicker = new PJQ.inputs.Selectpicker({
			el: this.$('.add-participants-union-filter'),
			isIntChoices: true,
			isMultiple: true,
			onChange: _.bind(function () {
				this.unionFilterSelectPicker.hideError();
			}, this)
		});

		this.renderGroups();

		if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_PACKAGES)) {
			this.renderBidPackages();
		}

		if (this.options.isWorkAreasEnabled) {
			if (this.locationFilter == null && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_LOCATION_FILTERS)) {
				this.locationFilter = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_LOCATION_FILTERS)
			}
			this.locationTypeSelector = new PJQ.inputs.Selectpicker({
				el: this.$('.add-participants-location-filter'),
				isIntChoices: true,
				isMultiple: true,
				defaultValue: this.locationFilter ? this.locationFilter.split(',') : [1, 2],
				onChange: _.bind(function (value) {
					let $radiusOuter = this.$('.radius-outer'),
						$boundariesOuter = this.$('.boundaries-outer');
					if (value.indexOf(2) === -1) {
						$radiusOuter.addClass('hidden');
						$boundariesOuter.addClass('hidden');
					}
					else {
						$radiusOuter.removeClass('hidden');
						$boundariesOuter.removeClass('hidden');
					}
				}, this)
			});
		}

		let radius = this.options.defaultRadius;
		if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.SIMPLE_SEARCH_DEFAULT_RADIUS)) {
			radius = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.SIMPLE_SEARCH_DEFAULT_RADIUS);
		}
		this.radiusSlider = new PJQ.Slider(this.$('.add-participants-radius-slider'), {
			ticks: [1, 50, 100, 150, 200, 250, 300],
			ticks_labels: [1, 50, 100, 150, 200, 250, 300],
			value: radius,
			onChange: _.bind(function (obj) {
				this.setRadius(obj.newValue);
			}, this)
		});
		this.setRadius(radius);
	},
	renderBidPackages: function () {
		this.bidPackageSelector = new PJQ.views.bidPackages.BidPackageSelector({
			el: this.$('.bid-package-selector'),
			project: PJQ.app.session.project,
			isIncludeGroups: true,
			onSelected: _.bind(function (groupIds, bidPackageIds) {
				this.selectedGroupIds = groupIds;
				this.selectedBidPackageIds = bidPackageIds;
			}, this)
		})
	},
	renderGroups: function () {
		let isPrivate = true,
			isPublic = false,
			hasGroupsLinked = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.HAS_GROUPS_LINKED),
			hasBidPackages = this.bidPackages != null && _.size(this.bidPackages.models) > 0;
		if (this.options.isDirectoryEnabled) {
			let selectedDirectoryValues = this.directoryFilterSelectPicker.getValue();
			isPrivate = _.size(selectedDirectoryValues) === 0 || _.indexOf(selectedDirectoryValues, 1) > -1;
			isPublic = _.indexOf(selectedDirectoryValues, 2) > -1;
		}

		let $publicA = this.$('a[href="#addParticipantsGroupsPublic"]'),
			$publicLi = $publicA.closest('li'),
			$privateA = this.$('a[href="#addParticipantsGroupsPrivate"]'),
			$privateLi = $privateA.closest('li'),
			$bidPackageA = this.$('a[href="#addParticipantsBidPackages"]'),
			$bidPackageLi = $bidPackageA.closest('li');

		if (this.groupSelectorPrivate != null) {
			this.groupSelectorPrivate.remove();
			this.groupSelectorPrivate = null;
		}
		if (this.groupSelectorPublic != null) {
			this.groupSelectorPublic.remove();
			this.groupSelectorPublic = null;
		}

		if (hasBidPackages || (isPrivate && isPublic && !hasGroupsLinked)) {
			this.$('.add-participants-groups-nav-bar').removeClass('hidden');

			if (hasBidPackages) {
				$bidPackageLi.removeClass('hidden');
				$bidPackageA.tab('show');
			}
			else{
				$bidPackageLi.addClass('hidden');
			}

			if(isPublic && !hasGroupsLinked){
				$publicLi.removeClass('hidden');
				$publicA.tab('show');
			}
			else{
				$publicLi.addClass('hidden');
			}

			if(isPrivate || (isPublic && hasGroupsLinked)){
				$privateLi.removeClass('hidden');
				$privateA.tab('show');
			}
			else{
				$privateLi.addClass('hidden');
			}
		}
		else {
			this.$('.add-participants-groups-nav-bar').addClass('hidden');
			if (!hasGroupsLinked) {
				if (isPrivate) {
					$privateA.tab('show');
				}
				else {
					$publicA.tab('show');
				}
			}
			else {
				$privateA.tab('show');
			}
		}

		let headerButtons = null;
		if (this.model.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_FORMS) && this.model.hasPermission('bidForms.canView')) {
			headerButtons = [
				{
					id: 'filterBFTrades',
					label: 'Select Bid Form Trades',
					callback: _.bind(function (selector) {
						let fnSelect = function (groupIds) {
							selector.selectGroups(groupIds);
							selector.expandSelectedParents();
						};
						if (this.options.bidFormGroupIds != null) {
							fnSelect(this.options.bidFormGroupIds);
						}
						else {
							let summary = new PJQ.collections.bidForms.BidFormsSummary(null, {
								projectId: this.model.id
							});
							summary.fetch({
								success: _.bind(function () {
									this.options.bidFormGroupIds = _.map(summary.models, function (summaryItem) {
										return summaryItem.get('groupId');
									});
									fnSelect(this.options.bidFormGroupIds);
								}, this)
							});

						}
					}, this)
				}
			];
		}

		if (isPrivate || (isPublic && hasGroupsLinked)) {
			this.groupSelectorPrivate = new PJQ.views.groups.GroupSelector(_.defaults({
				el: this.$('.group-selector-private'),
				headerButtons: headerButtons,
				onGroupSelected: _.bind(function () {
					this.groupSelectorPrivate.hideError();
				}, this)
			}, this.options.groupSelector));
		}

		if (isPublic && !hasGroupsLinked) {
			this.groupSelectorPublic = new PJQ.views.groups.GroupSelector(_.defaults({
				el: this.$('.group-selector-public'),
				isPublicGroups: true,
				headerButtons: headerButtons,
				onGroupSelected: _.bind(function () {
					this.groupSelectorPublic.hideError();
				}, this)
			}, this.options.groupSelector));
		}
	},
	numbersOnly: function (e) {
		return PJQ.helpers.inputHelpers.numbersOnly(e);
	},
	radiusChanged: function () {
		this.setRadius(parseInt(this.$('.add-participants-radius').val()));
	},
	setRadius: function (radius) {
		if (isNaN(radius) || radius < 1)
			radius = 1;
		else if (radius > 300)
			radius = 300;
		this.radiusSlider.setValue(radius);
		//don't set the radius input yet if the length of the value is 0 in case the user is trying to clear the input to enter a new value
		if (this.$('.add-participants-radius').val().length > 0)
			this.$('.add-participants-radius').val(radius);
	},
	onCancel: function () {
		if (typeof this.options.onCancel === 'function') {
			this.options.onCancel();
		}
	},
	sendMessage: function () {
		this.onSave(null, true);
	},
	onSave: function (e, isSendMessage = false) {
		let hasGroupsLinked = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.HAS_GROUPS_LINKED),
			publicGroups = this.groupSelectorPublic ? this.groupSelectorPublic.getGroupsData().selected : [],
			privateGroups = this.groupSelectorPrivate ? this.groupSelectorPrivate.getGroupsData().selected : [],
			radius = this.$('.add-participants-radius').val(),
			zipInput = this.$('.add-participants-zip'),
			zip = PJQ.helpers.formatHelpers.formatZip(zipInput.val()),
			directoryFilter = null,
			isPublic = true,
			isPrivate = false,
			canCrossStateBoundaries = this.$('.cb-can-cross-state-bounds').prop('checked'),
			locationFilter = 2,
			hasBidPackages = this.bidPackages != null && _.size(this.bidPackages.models) > 0;

		this.selectedGroupIds = _.union(privateGroups, publicGroups, this.selectedGroupIds);
		if (this.options.isWorkAreasEnabled) {
			let locationType = this.locationTypeSelector.getValue(),
				isWorkAreas = _.indexOf(locationType, 1) > -1,
				isOfficeLocation = _.indexOf(locationType, 2) > -1;
			if (isWorkAreas && isOfficeLocation) {
				locationFilter = 0;
			}
			else if (isWorkAreas) {
				locationFilter = 1;
			}
			else if (isOfficeLocation) {
				locationFilter = 2;
			}
		}

		if (this.options.isDirectoryEnabled) {
			let selectedDirectoryValues = this.directoryFilterSelectPicker.getValue(),
				isPrivate = _.indexOf(selectedDirectoryValues, 1) > -1,
				isPublic = _.indexOf(selectedDirectoryValues, 2) > -1;

			if (isPrivate && isPublic) {
				directoryFilter = 0;
			}
			else if (isPrivate) {
				directoryFilter = 1;
			}
			else if (isPublic) {
				directoryFilter = 2;
			}
		}

		let selectedUnionStatusValues = this.unionFilterSelectPicker.getValue(),
			isUnion = _.indexOf(selectedUnionStatusValues, 1) > -1,
			isNonUnion = _.indexOf(selectedUnionStatusValues, 2) > -1,
			isPrevailingWage = _.indexOf(selectedUnionStatusValues, 3) > -1,
			isNoLaborStatus = _.indexOf(selectedUnionStatusValues, 4) > -1;

		let isValid = true;
		if (this.directoryFilterSelectPicker != null) {
			if (directoryFilter == null) {
				this.directoryFilterSelectPicker.showError('You must select an address book');
				isValid = false;
			}
			else {
				this.directoryFilterSelectPicker.hideError();
			}
		}

		if (_.size(privateGroups) === 0 && isPrivate && !hasBidPackages) {
			if (!hasGroupsLinked) {
				this.groupSelectorPrivate.showError('You must select at least one private trade');
			}
			else {
				this.groupSelectorPrivate.showError('You must select at least one trade');
			}
			this.$('a[href="#addParticipantsGroupsPrivate"]').tab('show');
			isValid = false;
		}
		else if (this.groupSelectorPublic != null && _.size(publicGroups) === 0 && isPublic && !hasGroupsLinked && !hasBidPackages) {
			this.groupSelectorPublic.showError('You must select at least one public trade');
			this.$('a[href="#addParticipantsGroupsPublic"]').tab('show');
			isValid = false;
		}
		else if (this.bidPackageSelector != null && _.size(this.selectedGroupIds) === 0 && hasBidPackages) {
			this.bidPackageSelector.showError('You must select at least one trade or bid package');
			this.$('a[href="#addParticipantsBidPackages"]').tab('show');
			isValid = false;
		}
		else {
			if (this.groupSelectorPrivate != null) {
				this.groupSelectorPrivate.hideError();
			}
			if (this.groupSelectorPublic != null) {
				this.groupSelectorPublic.hideError();
			}
			if (this.bidPackageSelector != null) {
				this.bidPackageSelector.hideError();
			}
		}

		if (!PJQ.helpers.validators.validateZip(zip)) {
			PJQ.helpers.inputHelpers.setInputError(zipInput, false, {
				errorText: 'Invalid zip code'
			});
			isValid = false;
		}
		else {
			PJQ.helpers.inputHelpers.setInputError(zipInput, true);
		}

		if (isValid) {
			let loader = new PJQ.Loader(this.$('.modal-content'));
			this.model.addParticipants(this.selectedGroupIds != null ? this.selectedGroupIds : _.union(privateGroups, publicGroups), zip, radius, locationFilter, canCrossStateBoundaries, directoryFilter, isUnion, isNonUnion, isPrevailingWage, isNoLaborStatus, this.options.isReturnContactIds, _.bind(function (data) {
				this.removeModal();
				let participantCount = _.size(data);
				if (participantCount > 0) {
					PJQ.notifications.notify.successNotify({
						message: 'Successfully added ' + participantCount.toString() + ' participants'
					});
				}
				else {
					PJQ.notifications.notify.warningNotify({
						message: 'No new participants were found'
					});
				}

				if (typeof this.options.onSave === 'function') {
					this.options.onSave(data, isSendMessage);
				}
			}, this), function () {
				loader.remove();
				PJQ.notifications.notify.errorNotify({
					message: 'Failed to add participants to the project.  Please contact customer service.'
				});
			});
		}
	}
});

PJQ.views.projectParticipants.AddParticipantsFromProjectModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Add-Participants-From-Project'),
		addButtonText: "Add Participants",
		maxWidth: '650px',
		isBidFormsEnabled: false,
		isReturnContactIds: false,
		projectResponses: [],
		onSave: _.noop,
		onCancel: _.noop
	},
	events: {
		"click .add-participants-cancel": "onCancel",
		"click .add-participants-save": "onSave",
		"click .add-participants-select-projects-continue": "completeProjectsStep",
		"click .add-participants-select-trades-continue": "completeTradesStep",
		"click .add-participants-jump-step": "goToStepEvent"
	},
	beforeRender: function () {
		this.renderData = {
			options: this.options
		}
	},
	afterRender: function () {
		new PJQ.views.projects.ProjectSelector({
			el: this.$('.project-selector'),
			excludeProjectIds: [this.model.id],
			onProjectSelected: _.bind(function (projects) {
				this.selectedProjects = projects;
				this.renderSelectedProjectCount();
				this.$('.add-participants-select-projects-continue').prop('disabled', _.size(this.selectedProjects) === 0);
			}, this),
			dataTableHeaderData: {
				isHideDeletedFilter: true
			}
		});
		this.renderSelectedProjectCount();
		this.goToStep(1);
	},
	renderSelectedProjectCount: function () {
		let selectedProjectCount = _.size(this.selectedProjects);
		this.$('.add-participants-projects-count').html(selectedProjectCount.toString());
		if (this.step > 1) {
			this.$('.add-participants-selected-projects').html(selectedProjectCount.toString() + " selected");
		}
		else {
			this.$('.add-participants-selected-projects').empty();
		}
	},
	completeProjectsStep: function () {
		this.goToStep(2);
	},
	completeTradesStep: function () {
		this.goToStep(3);
	},
	goToStepEvent: function (e) {
		let step = parseInt($(e.currentTarget).data('step').toString());
		this.goToStep(step);
	},
	goToStep: function (step) {
		this.step = step;
		let thisStep = $('.step-' + this.step.toString()),
			thisStepHeader = $('.step-header-' + this.step.toString());
		this.$('[class*=step-]').not(thisStep).collapse('hide');
		this.$('[class*=step-header-]').not(thisStepHeader).removeClass('text-primary').addClass('text-dark op-4');
		thisStepHeader.removeClass('text-dark op-4').addClass('text-primary');
		thisStep.collapse('show');
		this.startStep();
	},
	startStep: function () {
		switch (this.step) {
			case 1:
				this.$('.add-participants-selected-project-name').empty();
				this.$('.add-participants-selected-trades').empty();
				break;
			case 2:
				this.$('.add-participants-selected-trades').empty();
				let request = new PJQ.ajax.Request({
					endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
						{
							endpoint: 'projects',
							value: 0
						},
						{
							endpoint: 'groups'
						}
					], [
						{
							parameter: 'projects',
							value: _.map(this.selectedProjects, function (project) {
								return project.id;
							}).join(',')
						}
					])
				});
				request.get().done(_.bind(function (data) {
					this.createGroupSelector(new PJQ.collections.groups.Groups(data, {
						groupLevels: PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS)
					}));
				}, this));
				break;
			case 3:
				for (let i = 0; i < this.options.projectResponses.length; i++) {
					let res = this.options.projectResponses[i];
					if (PJQ.helpers.objectHelpers.refinedType(res) === 'array') {
						res = res[0];
					}
					let resLower = res.toLowerCase();
					if (resLower !== "yes" && resLower !== "no" && resLower !== "true" && resLower !== "false") {
						let option = "<option value='" + res + "'>" + res + "</option>";
						this.$('select.add-participants-response-filter').append(option);
					}
				}

				this.projectResponseFilterSelectPicker = new PJQ.inputs.Selectpicker({
					el: this.$('.add-participants-response-filter'),
					isMultiple: true
				});
				break;
		}
		this.renderSelectedProjectCount();
		this.renderSelectedGroupCount();
		this.$('.add-participants-save').prop('disabled', this.step !== 3);
	},
	createGroupSelector: function (groups) {
		if (_.size(groups.models) > 0) {
			this.$('.select-trades-instruction').show();

			let headerButtons = null;
			if (this.model.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_FORMS) && this.model.hasPermission('bidForms.canView')) {
				headerButtons = [
					{
						id: 'filterBFTrades',
						label: 'Select Bid Form Trades',
						callback: _.bind(function (selector) {
							let fnSelect = function (groupIds) {
								selector.selectGroups(groupIds);
								selector.expandSelectedParents();
							};
							if (this.options.bidFormGroupIds != null) {
								fnSelect(this.options.bidFormGroupIds);
							}
							else {
								let summary = new PJQ.collections.bidForms.BidFormsSummary(null, {
									projectId: this.model.id
								});
								summary.fetch({
									success: _.bind(function () {
										this.options.bidFormGroupIds = _.map(summary.models, function (summaryItem) {
											return summaryItem.get('groupId');
										});
										fnSelect(this.options.bidFormGroupIds);
									}, this)
								});

							}
						}, this)
					}
				];
			}
			this.groupSelector = new PJQ.views.groups.GroupSelector({
				el: this.$('.group-selector'),
				isShowNoGroup: true,
				groups: groups.models,
				headerButtons: headerButtons,
				onGroupSelected: _.bind(function () {
					this.selectedGroups = this.groupSelector.getGroupsData().new;
					this.renderSelectedGroupCount();
					this.$('.add-participants-select-trades-continue').prop('disabled', _.size(this.selectedGroups) === 0);
				}, this)
			});
			this.renderSelectedGroupCount();
		}
		else {
			this.$('.select-trades-instruction').hide();
			new PJQ.Alert(this.$('.group-selector'), {
				type: 'warning',
				text: _.size(this.selectedProjects) > 0 ? 'These projects do not contain any trades' : 'This project does not contain any trades'
			});
		}
	},
	renderSelectedGroupCount: function () {
		let selectedGroupCount = _.size(this.selectedGroups);
		this.$('.add-participants-trades-count').html(selectedGroupCount);
		if (this.step > 2) {
			this.$('.add-participants-selected-trades').html(selectedGroupCount.toString() + " selected");
		}
		else {
			this.$('.add-participants-selected-trades').empty();
		}
	},
	onCancel: function () {
		if (typeof this.options.onCancel === 'function') {
			this.options.onCancel();
		}
	},
	onSave: function () {
		let isCopyBidForms = this.options.isBidFormsEnabled ? this.$('.add-participants-copy-bid-forms').prop('checked') : false,
			responseFilter = _.size(this.options.projectResponses) > 0 ? this.projectResponseFilterSelectPicker.getValue() : [],
			request = new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'projects',
						value: this.model.id
					},
					{
						endpoint: 'participants'
					},
					{
						endpoint: 'copy'
					}
				], [
					{
						parameter: 'projects',
						value: _.map(this.selectedProjects, function (project) {
							return project.id;
						}).join(',')
					}
				]),
				data: {
					groupIds: _.map(this.selectedGroups, function (group) {
						return group.id;
					}),
					isCopyBidForms: isCopyBidForms,
					projectResponses: responseFilter
				}
			}),
			loader = new PJQ.Loader(this.$('.modal-content'));
		request.post().done(_.bind(function (response) {
			this.removeModal();
			let message = "";
			if (response.participantsCopied.length > 0 || response.bidFormsCopied > 0) {
				if (isCopyBidForms && response.bidFormsCopied > 0) {
					message = response.participantsCopied.length.toString() + (response.participantsCopied.length === 1 ? ' participant' : ' participants') + ' and ' + response.bidFormsCopied.toString() + ' bid ' + (response.bidFormsCopied === 1 ? 'form' : 'forms') + ' copied successfully.';
				}
				else {
					message = response.participantsCopied.length.toString() + (response.participantsCopied.length === 1 ? ' participant' : ' participants') + ' copied successfully.';
				}
				PJQ.notifications.notify.successNotify({
					message: message
				});
			}
			else {
				if (isCopyBidForms) {
					message = "No new participants or bid forms could be found on the selected project";
				}
				else {
					message = "No new participants could be found on the selected project";
				}
				PJQ.notifications.notify.warningNotify({
					message: message
				});
			}

			if (typeof this.options.onSave === 'function') {
				this.options.onSave(this.options.isReturnContactIds ? response.contactsCopied : response.participantsCopied);
			}
		}, this)).fail(function () {
			loader.remove();
			PJQ.notifications.notify.errorNotify({
				message: 'Failed to add bidders to the project'
			});
		});
	}
});
